/**
 * Attribution lookback: ALL TIME, for every brand, always — see the LOOKBACK
 * note in backend services/attribution/models. It used to be a choice on each
 * attribution view; it is no longer offered, so every report credits the same
 * journeys. `'all'` is what the API takes and echoes.
 */

export const DEFAULT_LOOKBACK = 'all'

/** "all-time" or "30-day", for "… lookback before each payment". */
export const lookbackAdjective = days => (days === 'all' ? 'all-time' : `${days}-day`)
